export default __webpack_public_path__ + "static/media/TEL.036688f2.jpg";